import {observer} from 'mobx-react';
import {Note} from "../../../../../../../components/note/note";

interface IProps {}

const CanadaPostCredentials: React.FC<IProps> = observer(() => {

    return (
        <>
            <Note body={'Integrate your ReturnGO account with an existing or new Canada Post account.'}/>
        </>
    );
});

export default CanadaPostCredentials;
